import styled from '@emotion/styled'

import { IMPORTED_INVOICE_SYNC_STATUS_WIDTH } from './constants/importedInvoiceSyncStatusWidth'

// The DS `Tag` is `white-space: nowrap`, and the wrapper the table renders around
// `renderAsChildren` cells has no width of its own — so its flex minimum resolves to the
// tag's full width and a long localised label spills out of the table instead of
// truncating. A definite `max-width` clamps that minimum back to the column width.
export const ImportedInvoiceSyncStatusWrapper = styled.div`
  display: flex;
  justify-content: center;
  max-width: ${IMPORTED_INVOICE_SYNC_STATUS_WIDTH}px;

  /* Tooltip renders an unstyled div around the tag; as a flex item its automatic
     minimum size is the tag's nowrap width, which is what defeats the truncation. */
  > div {
    min-width: 0;
  }
`
